export default class TargetManager {

    constructor() {

        this.calculateTargetValue = this.calculateTargetValue.bind(this);
        this.getRelevantTarget = this.getRelevantTarget.bind(this);
    }

    calculateTargetValue(lastYearValue, period, identity) {

        let targets = zzDataCache.targets;

        if (targets === undefined || targets === null || targets.generalTarget === null) {
            return lastYearValue;
        }

        let daysOpen = targets.locationToDaysInWeek[identity.locationId];
        if (daysOpen === undefined || daysOpen === null) {
            daysOpen = targets.locationToDaysInWeek[Object.keys(targets.locationToDaysInWeek)[0]];
            if (daysOpen === undefined || daysOpen === null) {
                daysOpen = 6;
            }
        }

        let dayMultiplier = 1;
        switch (period) {
            case 'WTD': dayMultiplier = (daysOpen) * zzDataCache.calendarRatios.wk; break;
            case 'MTD': dayMultiplier = (daysOpen * 4.34524) * zzDataCache.calendarRatios.mth; break;
            case 'QTD': dayMultiplier = (daysOpen * 13.03572) * zzDataCache.calendarRatios.qtr; break;
            case 'YTD': dayMultiplier = (daysOpen * 52.14288) * zzDataCache.calendarRatios.yr; break;
        }

        let relevantTarget = this.getRelevantTarget(identity);

        let isPositive = (identity.sign === undefined || identity.sign === null || identity.sign === '' || identity.sign === '+');

        let percValue = isPositive ? lastYearValue * ((100.0 + relevantTarget.percentDelta) / 100.0) : lastYearValue * ((100.0 - relevantTarget.percentDelta) / 100.0);
        let minMaxValue = relevantTarget.dailyMinMax;
        if (minMaxValue === 0) {
            minMaxValue = lastYearValue;
        } else if (!identity.isAvg && identity.type != 'PCT') {
            minMaxValue = minMaxValue * dayMultiplier;
        }

        let result = minMaxValue === 0 ? percValue :
            (isPositive ? (percValue >= minMaxValue ? percValue : minMaxValue) : (percValue <= minMaxValue ? percValue : minMaxValue));

        if (result === 0) {
            result = lastYearValue;
        }

        return result
    }

    getRelevantTarget(identity) {
        let targets = zzDataCache.targets;
        let relevantTarget = targets.generalTarget;

        let filterFunc = (r, e) => {
            if ((e.locationId === null && e.reportKpiId === identity.reportKpiId) ||
                (e.locationId != null && e.reportKpiId === identity.reportKpiId && e.locationId === identity.locationId)) {
                r = e;
            }
            return r;
        };

        relevantTarget = targets.defaultLocationTargets.reduce(filterFunc, relevantTarget);
        relevantTarget = targets.defaultEmployeeTargets.reduce(filterFunc, relevantTarget);
        relevantTarget = targets.locationTargets.reduce(filterFunc, relevantTarget);
        relevantTarget = targets.employeeTargets.reduce(filterFunc, relevantTarget);

        return relevantTarget;
    }
}